// removed by extract-text-webpack-plugin
module.exports = {"comingSoonLabel":"src-components-ComingSoonLabels-___index__comingSoonLabel___1PIra"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ComingSoonLabels/index.css
// module id = 1064
// module chunks = 3